@if (!isLoading) {
<div>
  <div class="ot-row">
    <div class="otsc-prop-header">
      <h1 id="notifications-header" class="otsc-prop-header-text" i18n>Notifications</h1>
      <div class="ot-btn-group otsc-prop-header-btn">
        <button id="otsc-settings-notification-save-btn" role="button" class="ot-btn ot-btn--is-primary"
          (click)="save()"
          [disabled]="settingsForm && (!settingsForm.dirty || settingsForm.invalid || (isPurgeActiveCtrl.value && selectedItems.length == 0))">
          {{savingBtn}}
        </button>
        <button id="otsc-settings-notification-reset-btn" role="button" class="ot-btn ot-btn--is-secondary"
          (click)="reset()" [disabled]="settingsForm && !settingsForm.dirty" i18n>
          Reset
        </button>
      </div>
    </div>
  </div>
  <form [formGroup]="settingsForm" name="otsc-settings-proxy-form">
    <div style="height: calc(100vh - 160px);">
      <ng-scrollbar #scrollbarRef>
        <div class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-2">
          <div id="otsc-enable-notification-cleanup">
            <app-checkbox [identifier]="'isPurgeActive'" formControlName="isPurgeActiveCtrl" [name]="'isPurgeActive'"
              [toggle]="true" i18n-label [label]="'Automatic notification purge'" i18n-arialabel
              [arialabel]="'Enable/disable automatic notification purge'" i18n-description
              [description]="'Automatically remove selected notification types'"
              (ngModelChange)="activatePurgeChange()">
            </app-checkbox>
          </div>
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-33">
              <div class="ot-form-control"
                [ngClass]="{'ot-form-control--is-invalid' : isPurgeActiveCtrl.value == true && notificationRetentionPeriodCtrl.invalid}">
                <label id="notification-purge-label" class="ot-form-control__label" for="notificationRetentionPeriod"
                  i18n>
                  Notification retention period (days)
                </label>
                <div class="ot-form-control__input-group">
                  <input id="notificationRetentionPeriod" formControlName="notificationRetentionPeriodCtrl"
                    placeholder="Enter retention period" type="number" maxlength="2"
                    class="ot-input ot-input--is-expanded" [readonly]="!isPurgeActiveCtrl.value">
                  <span class="ot-form-control__error-icon">
                  </span>
                </div>
                @if (notificationRetentionPeriodCtrl.invalid) {
                <p id="invalidNotificationRetentionPeriodtMsg" class="ot-form-control__error-text" i18n
                  autocomplete="off">
                  Invalid time specified. Please select a time period between 1 and 90 days.
                </p>
                }
                <p id="notification-purge-description" class="ot-form-control__info-text" i18n>The value can be set
                  between 1 and 90 days.</p>
              </div>
            </div>
          </div>
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-75">
              <div class="ot-form-control">
                <label for="notificationPurgeList"
                  class="ot-form-control__label ot-form-control__label--for-group">Notifications to purge</label>
                <div class="ot-checkbox-group">
                  <div class="ot-checkbox-options ot-grid--is-3-columns">
                    <app-checkbox [identifier]="'select-all-types'" [(ngModel)]="selectAll"
                      (ngModelChange)="selectAllChange($event)" i18n-label [label]="selectAllText" i18n-arialabel
                      [arialabel]="selectAllText" [ngModelOptions]="{standalone: true}"
                      [disabled]="!isPurgeActiveCtrl.value">
                    </app-checkbox>
                    @for (checkbox of typeCtrls | keyvalue; track checkbox) {
                    <app-checkbox i18n-label [formControl]="checkbox.value" name="notification-type"
                      [dataName]="checkbox.key" [label]="getTypeText(checkbox.key)" i18n-arialabel
                      [arialabel]="getTypeText(checkbox.key)" [ngModelOptions]="{standalone: true}"
                      (change)="selectChange($event)">
                    </app-checkbox>
                    }
                  </div>
                </div>
                @if (isPurgeActiveCtrl.value && selectedItems.length == 0) {
                <p id="notification-list-empty-error" class="ot-form-control--is-invalid ot-form-control__error-text"
                  autocomplete="off" i18n>Please make a selection</p>
                }
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  </form>
</div>
} @else {
<div id="notification-loading"
  class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter">
    </div>
  </div>
  <div class="ot-progress__text" id="otsc-settings-proxy-loading" i18n>Loading...</div>
</div>
}